import { ILabelProps, Label as FluentLabel } from "@fluentui/react";

export type LabelProps = ILabelProps;

export const Label = FluentLabel;
